/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BrickSnake2000GameAssets} from "../BrickSnake2000GameAssets";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {gsap} from "gsap";
import {BrickSnake2000} from "../BrickSnake2000";

export class BrickSnake2000BackgroundElements extends PIXI.Container implements StageLayer {

    private baseGame:PIXI.Sprite;
    private freespins:PIXI.Sprite;
    private superFreespins:PIXI.Sprite;
    private sfsReelEffect:PIXI.spine.Spine;
    private currentMode:GameMode;

    constructor() {
        super();
        this.name = "BrickSnake2000BackgroundElements";
        this.init();
    }

    private init() {
        this.currentMode = GameMode.NORMAL;

        this.baseGame = new PIXI.Sprite(BrickSnake2000.assetLoader.getTextures(BrickSnake2000GameAssets.BASE_GAME_BACKGROUND)[0]);
        this.baseGame.position.set(360,360);
        this.baseGame.anchor.set(0.5,0.5);

        this.freespins = new PIXI.Sprite(BrickSnake2000.assetLoader.getTextures(BrickSnake2000GameAssets.FREESPINS_BACKGROUND)[0]);
        this.freespins.position.set(360,360);
        this.freespins.anchor.set(0.5,0.5);
        this.freespins.alpha = 0;

        this.superFreespins = new PIXI.Sprite(BrickSnake2000.assetLoader.getTextures(BrickSnake2000GameAssets.SUPER_FREESPINS_BACKGROUND)[0]);
        this.superFreespins.position.set(360,360);
        this.superFreespins.anchor.set(0.5,0.5);
        this.superFreespins.alpha = 0;

        this.addChild(this.baseGame);
        this.addChild(this.freespins);
        this.addChild(this.superFreespins);

        this.onOrientationChanged();
        this.onResize();
    }

    public onOrientationChanged() {

    }

    public onResize() {
    }

    private enableSfsStuff():gsap.core.Timeline {
        return gsap.timeline()
            .add(gsap.to(this.superFreespins, {alpha: 1, duration: 0.2}));
    }

    private disableSfsStuff():gsap.core.Timeline {
        return gsap.timeline()
            .add(gsap.to(this.superFreespins, {alpha: 0, duration: 0.2}));
    }

    public setToFreespins():gsap.core.Timeline {
       return gsap.timeline()
           .add(() => {
               this.currentMode = GameMode.FREESPIN;
           })
           .add(gsap.to(this.baseGame, {alpha: 0, duration: 0.2}))
           .add(gsap.to(this.freespins, {alpha: 1, duration: 0.2}), '<')
    }

    public setToSuperFreespins():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.currentMode = GameMode.FREESPIN_SUPER;
            })
            .add(this.currentMode == GameMode.FREESPIN
                ? gsap.to(this.freespins, {alpha: 0, duration: 0.2})
                : gsap.to(this.baseGame, {alpha: 0, duration: 0.2}), '<')
            .add(this.enableSfsStuff(), '<');
    }

    public setToBaseGame():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.currentMode = GameMode.NORMAL;
            })
            .add(gsap.to(this.baseGame, {alpha: 1, duration: 0.2}))
            .add(this.currentMode == GameMode.FREESPIN
                 ? gsap.to(this.freespins, {alpha: 0, duration: 0.2})
                 : this.disableSfsStuff(), '<');
    }

    public restore(mode:GameMode):void {
       this.currentMode = mode;
       if (this.currentMode == GameMode.NORMAL){
           this.baseGame.alpha = 1;
           this.freespins.alpha = 0;
           this.superFreespins.alpha = 0;
       } else if (this.currentMode == GameMode.FREESPIN) {
           this.baseGame.alpha = 0;
           this.freespins.alpha = 1;
           this.superFreespins.alpha = 0;
       } else if (this.currentMode == GameMode.FREESPIN_SUPER) {
           this.baseGame.alpha = 0;
           this.freespins.alpha = 0;
           this.superFreespins.alpha = 1;
       }
    }
}